import { IconButton } from "@mui/material";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import Typography from "@mui/material/Typography";
import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useSelector } from 'react-redux';
import { ReduxStore } from '../../../model/ReduxStore';
import { blogData } from "../../../model/BlogData";
import { PathNames } from "../../../appConfig/PathNames";
import { StringExtensions } from "../../../utility/StringExtensions";
import { RoleUtility } from "../../../utility/RoleUtility";
import SendMenu from "../../../components/SocialMedia/SendMenu";

const Blog = (props:
    {
        blog: blogData,
        onEdit?: (blog: blogData) => void,
        onPublish?: (blog: blogData) => void,
        onDelete?: (blog: blogData) => void
    }) => {
    const currentUser = useSelector((state: ReduxStore) => state?.userData?.user);

    const [showMenu, setShowMenu] = React.useState<boolean>(false);
    const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
    const open = Boolean(anchorEl);
    const handleClick = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };
    const navigate = useNavigate();
    const path = useLocation();

    React.useEffect(() => {
        let pathArray = path.pathname?.split("/");
        if (pathArray && pathArray.length >= 1
            && pathArray[1]?.toLowerCase() === PathNames.ADMIN_PANEL.split("/")[1]?.toLowerCase()
            && (RoleUtility.isAdmin(currentUser?.role) === true)) {
            setShowMenu(true);
        }
    }, []);

    const AdminMenu = () => {
        return (
            <div>
                <IconButton
                    id="menu-icon-button"
                    aria-controls={open ? 'menu-icon-button' : undefined}
                    aria-haspopup="true"
                    aria-expanded={open ? 'true' : undefined}
                    onClick={handleClick}
                    disableRipple={true}
                    disableFocusRipple={true}
                    sx={{ position: "absolute", right: 0, top: 0 }}
                >
                    <MoreHorizIcon color='primary' />
                </IconButton>
                <Menu
                    id="menu-icon-button"
                    aria-labelledby="menu-icon-button"
                    anchorEl={anchorEl}
                    open={open}
                    onClose={handleClose}
                    anchorOrigin={{
                        vertical: 'top',
                        horizontal: 'left',
                    }}
                    transformOrigin={{
                        vertical: 'top',
                        horizontal: 'left',
                    }}
                >
                    <MenuItem onClick={handleClose} disabled>State: {StringExtensions.humanize(props.blog.status)}</MenuItem>
                    <MenuItem onClick={() => props.onEdit!(props.blog)}>Edit</MenuItem>
                    {(props.blog.status === 'draft') &&
                        <MenuItem onClick={() => {
                            props.onPublish && props.onPublish!(props.blog);
                            handleClose();
                        }}>Publish</MenuItem>
                    }
                    <MenuItem onClick={() => {
                        props.onDelete && props.onDelete!(props.blog);
                        handleClose();
                    }}>
                        Delete
                    </MenuItem>
                </Menu>
            </div>
        );
    };

    return <Box sx={{
        marginX: '5px',
        width: "calc(100%-10px)",
        marginTop: '55px',
        minHeight: '150px',
        borderRadius: '10px',
        boxShadow: "rgba(0, 0, 0, 0.16) 0px 3px 6px, rgba(0, 0, 0, 0.23) 0px 3px 6px"
    }}>
        <Box sx={{ position: "relative", padding: '10px' }}>
            <Box sx={{
                position: "absolute",
                top: "-45px",
                left: "20px",
                width: '175px',
                height: '175px',
                borderRadius: '10px',
                backgroundColor: '#354773',
                boxShadow: "rgba(0, 0, 0, 0.16) 0px 3px 6px, rgba(0, 0, 0, 0.23) 0px 3px 6px"
            }}>
                <img
                    src={props.blog.blog_display_pic}
                    alt={props.blog.title}
                    width="100%"
                    height="100%"
                />
            </Box>
            <Box sx={{
                position: "absolute",
                right: "0px",
                top: "0px",
                left: "195px",
                borderRadius: '10px'
            }}>
                <Box sx={{
                    margin: '10px',
                    display: "flex",
                    flexDirection: 'column',
                    justifyContent: 'space-between',
                    height: '130px'
                }}>
                    <Box sx={{ display: "flex", height: "100%", flexDirection: "column", "&>div": { marginY: "auto" } }}>
                        {showMenu && AdminMenu()}
                        <Typography component="div" color="primary" sx={{ fontWeight: 700, fontSize: '14px', lineHeight: '17.68px', paddingRight: "20px" }}>
                            {props.blog.title}
                        </Typography>
                        <Typography component="div" variant="body1" sx={{ fontWeight: 400, fontSize: '12px', lineHeight: '15.15px' }}>
                            {props.blog.description && props.blog.description.substring(0, 255)}
                        </Typography>
                        <Typography component="div">
                            <Typography color="primary" sx={{ fontWeight: 700, fontSize: '14px', lineHeight: '17.68px', paddingRight: "20px" }}>Author: </Typography>
                            <Typography sx={{ fontSize: "12px" }}>{props.blog.created_by}</Typography>
                        </Typography>
                        <Typography component="div" variant="body1" >
                            <Typography color="primary" sx={{ fontWeight: 700, fontSize: '14px', lineHeight: '17.68px', paddingRight: "20px" }}>Publication Date: </Typography>
                            <Typography sx={{ fontSize: "12px" }}>{props.blog.publishDate}</Typography>
                        </Typography>
                    </Box>
                    <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'flex-end', "& .generic-share-button span": { color: '#0f9764' } }}>
                        <SendMenu sendText="Share" visibleSendIcon={false} url={`/blogs/${props.blog.name}`} />
                        <Button
                            variant="text"
                            color="primary"
                            onClick={() => navigate(`/blogs/${props.blog.name}`)}
                            sx={{ fontWeight: 400, fontSize: '12px', lineHeight: '15.15px', paddingY: 0, paddingX: '5px' }}>{`Read More..`}</Button>
                    </Box>
                </Box>
            </Box>
        </Box>
    </Box>;
}

export default Blog;